import { Button, Col, Typography } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import { useDiscountCode, useTableDiscountCode } from "../hooks";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { DataDiscountCode } from "../../../redux/@types";
import Table from "../../../shared/components/ui/Table";
import { discountsService } from "../../../shared/services";

const { Title } = Typography;

export const TableDiscountCode = () => {
  const { changeDiscountCodeForUpdate, showDeleteConfirm } =
    useTableDiscountCode();
  const { setTableProps, updateStatus, isLoading } = useDiscountCode();

  const columns: TableColumns<DataDiscountCode> = [
    {
      title: "ID",
      width: 3,
      dataIndex: "id",
      key: "id",
      filterType: "filterByID",
    },
    {
      title: "Nombre",
      width: 5,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Código",
      width: 5,
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Estado",
      width: 4,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
              disabled={isLoading}
              onClick={() => {
                if (item.status === "active") {
                  updateStatus("inactive", item.id);
                } else if (item.status === "inactive") {
                  updateStatus("active", item.id);
                }
              }}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 4,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              shape="circle"
              onClick={() => changeDiscountCodeForUpdate(item)}
              icon={<EditOutlined />}
              size="large"
            />
            <Button
              type="primary"
              danger
              onClick={() => showDeleteConfirm(item.id, `${item.name}`)}
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];
  return (
    <Table<DataDiscountCode>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={discountsService}
      onLoad={setTableProps}
    />
  );
};
